/** Lowercases and trims emails so login/signup match regardless of casing. */
export const normalizeEmail = (email: string): string =>
  email.trim().toLowerCase();
